import { render, staticRenderFns } from "./prodItem.vue?vue&type=template&id=aad0ea54&scoped=true"
import script from "./prodItem.vue?vue&type=script&lang=js"
export * from "./prodItem.vue?vue&type=script&lang=js"
import style0 from "./prodItem.vue?vue&type=style&index=0&id=aad0ea54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad0ea54",
  null
  
)

export default component.exports